import * as React from 'react';
export class Column extends React.Component {
    render() {
        return null;
    }
}
Object.defineProperty(Column, "isColumn", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: true
});
